module.exports = __webpack_public_path__ + "img/IHG-MG.b2e76a21.png";